import { render, staticRenderFns } from "./PurchasesTable.vue?vue&type=template&id=2ca86f10&scoped=true&"
import script from "./PurchasesTable.vue?vue&type=script&lang=js&"
export * from "./PurchasesTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesTable.vue?vue&type=style&index=0&id=2ca86f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca86f10",
  null
  
)

export default component.exports